import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import { jwtDecode } from "jwt-decode";
import { formatDateTime, formatDate, useDepartmentFilter } from '../../../../utils/DateFormat';
import { filterStyle, filterWrapperStyle } from "../../styles/filterStyles";

function ProposalReport() {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);
  const { t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetProposalStatusList, GetBudgetHeadInfo, Usermenu, GetMyDepartmentAccess } = context;

  const { departments, departmentId, setDepartmentId, ready } = useDepartmentFilter(GetMyDepartmentAccess);

  const [RoleID, setroleID] = useState(null);
  const [proposallist, setProposalList] = useState([]);
  const budgetEstimation = proposallist;
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [openDistrict, setOpenDistrict] = useState(false);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLast = currentPage * billsPerPage;
  const indexOfFirst = indexOfLast - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirst, indexOfLast);
  const [exportingPDF, setExportingPDF] = useState(false);
  const [typeofData, settypeofData] = useState("District");
  const [UserRole, setUserRole] = useState("State");
  const [loading, setloading] = useState(false);
  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

  // const allDistricts = [
  //   ...new Set(
  //     AllDistrict?.map((d) =>
  //       d.District_Marathi?.split("-")[0]?.trim()
  //     )
  //   )
  // ];
  //////////Added
  const allDistricts = [
    ...new Set(
      AllDistrict?.map((d) =>
        (d?.District_Marathi || "").split("-")[0].trim()
      ).filter(Boolean)
    ),
  ].sort();
  const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const toggleDistrict = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };
  // useEffect(() => {
  //   if (SelectedDistrict && SelectedDistrict.length > 0) {
  //     const res = AllDistrict.filter((item) => {
  //       const itemDistrict = item?.District_Marathi || "";

  //       return SelectedDistrict.some(
  //         (district) =>
  //           itemDistrict === district ||
  //           itemDistrict.startsWith(`${district}-`)
  //       );
  //     });

  //     setTalukasofDistrict(res);
  //   } else {
  //     // setSelectedDistrict([]);
  //     setSelectedTalukasofDistrict("");
  //     setTalukasofDistrict([]);
  //   }
  // }, [SelectedDistrict, AllDistrict]);
  // //////////////Added
  useEffect(() => {
    if (SelectedDistrict && SelectedDistrict.length > 0) {
      const res = AllDistrict.filter((item) => {
        const d = item?.District_Marathi || "";
        return SelectedDistrict.some(
          (s) => d === s || d.startsWith(`${s}-`)
        );
      });
      setTalukasofDistrict(SelectedDistrict.length > 1 ? [] : res);
    } else {
      setSelectedTalukasofDistrict("");
      setTalukasofDistrict([]);
    }
  }, [SelectedDistrict, AllDistrict]);

  useEffect(() => {
    setSelectedTalukasofDistrict("");
  }, [SelectedDistrict]);

  // 🔹 Toggle single district
  useEffect(() => {
    let filtered = [...budgetEstimation];
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }
    filtered = filtered.filter((item) => {
      // 🔹 District filter (MULTI)
      // if (SelectedDistrict && SelectedDistrict.length > 0) {
      //     const itemDistrict = item?.District || "";

      //     const isDistrictMatched = SelectedDistrict.some(
      //       (district) =>
      //         itemDistrict === district ||
      //         itemDistrict.startsWith(`${district}-`)
      //     );

      //     if (!isDistrictMatched) {
      //       return false;
      //     }
      //   }

      // //////////////Addedd
      if (SelectedDistrict && SelectedDistrict.length > 0) {
        const itemDistrict = item.District || "";
        const matched = SelectedDistrict.some(
          (d) => itemDistrict === d || itemDistrict.startsWith(`${d}-`)
        );
        if (!matched) return false;
      }


      // 🔹 Taluka filter (single – unchanged)
      if (
        SelectedTalukasofDistrict &&
        item.Taluka !== SelectedTalukasofDistrict
      ) {
        return false;
      }

      // 🔹 Year filter (single)
      if (selectedYear && item.Proposal_year !== selectedYear) {
        return false;
      }
      return true;
    });

    // 🔹 Search filter (last)
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    budgetEstimation,
    SelectedDistrict, // array
    SelectedTalukasofDistrict,
    selectedYear,
    searchTerm,
    typeofData,
  ]);

  const proposalEstimate = async () => {
    try {
      const data = await GetProposalStatusList(departmentId);
      let list = data.message || data;

      if (list && list.length > 0) {
        // Sort latest by date descending
        list.sort((a, b) => new Date(b.Date) - new Date(a.Date));
        setProposalList(list);
        setCurrentPage(1);
      } else {
        setProposalList([]);
      }
    } catch (err) {
      // console.error(err);
      setProposalList([]);
    }
  };

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };

  useEffect(() => {
    getmenu();
  }, []);
  
  useEffect(() => {
    if (!ready) return;
    proposalEstimate();
  }, [ready, departmentId]);

  const renderStatus = (value) => {
    if (value === 1 || value === "1" || value === true) {
      return (
        <div
          className="m-auto"
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "6px",
            backgroundColor: "#16C60C", // green
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "18px",
            color: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          ✓
        </div>
      );
    } else if (value === 0 || value === "0" || value === false) {
      return (
        <div
          className="m-auto"
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "6px",
            backgroundColor: "#dc2626", // red
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "18px",
            color: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          ✕
        </div>
      );
    } else {
      return "-";
    }
  };
  const totalProposalAmount = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.Proposal_amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const exportTableByClassToExcel = async (
    filteredBills,
    filename = "Project_Status_Report.xlsx",
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalWorkAmount = 0;

      const excelData = filteredBills.map((proposal, index) => {
        const workAmount = Number(proposal.Proposal_amount || 0);
        totalWorkAmount += isNaN(workAmount) ? 0 : workAmount;

        return {
          "Sr No": index + 1,
          "Head Code": proposal.HeadCode || "-",
          "Work Name": proposal.Work_name || "-",
          "Job ID": proposal.ProposalID || "-",
          "Proposal Year": proposal.Proposal_year || "-",
          District: proposal.District || "-",
          Taluka: proposal.Taluka || "-",
          "Proposal File No": proposal.Proposal_fileNumber || "-",
          "Work Amount": workAmount,
          "Creation Date": proposal.created_at
            ? new Date(proposal.created_at).toLocaleString()
            : "-",

          /* ---- STATUS COLUMNS ---- */
          "Proposal Status": proposal.ProposalStatus ? "✓" : "✕",
          "GR Status": proposal.GRStatus ? "✓" : "✕",
          "Technical Sanction Status": proposal.TechnicalSanctionStatus
            ? "✓"
            : "✕",
          "Work Order Status": proposal.WorkOrderStatus ? "✓" : "✕",
          "Physical Progress Status": proposal.PhysicalProgressValue
            ? "✓"
            : "✕",
          "Demand Request Status": proposal.DemandRequestStatus ? "✓" : "✕",
          "Limit Allocation Status": proposal.LimitAllocation ? "✓" : "✕",
          "Bill Creation Status": proposal.BillStatus ? "✓" : "✕",
        };
      });

      /* ---- TOTAL ROW ---- */
      excelData.push({
        "Sr No": "",
        "Head Code": "",
        "Work Name": "",
        "Proposal Year": "",
        District: "",
        Taluka: "",
        "Proposal File No": "",
        "Work Amount": totalWorkAmount,
        "Creation Date": "",
        "Proposal Status": "",
        "GR Status": "",
        "Technical Sanction Status": "",
        "Work Order Status": "",
        "Physical Progress Status": "",
        "Demand Request Status": "",
        "Limit Allocation Status": "",
        "Bill Creation Status": "TOTAL",
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* ---- COLUMN WIDTH ---- */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));

      /* ---- FREEZE HEADER ---- */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* ---- AUTOFILTER (exclude total row) ---- */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 2,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Project Status Report",
      );

      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };
  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500; // change if needed (300–500 ideal)

    setExportingPDF(true);
    setloading(true);

    // 🔥 Allow loader to render
    await new Promise((resolve) => setTimeout(resolve, 600));

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      setloading(false);
      return;
    }

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, totalRows);

        // 🔥 Clone only current chunk
        const table = originalTable.cloneNode(true);
        const rows = table.querySelectorAll("tbody tr");

        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        document.body.appendChild(table);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(table, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(table);

        // 🔥 Small delay between chunks (prevents freeze)
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };

  const pagetotalProposalAmount = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.Proposal_amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  ///////////////////Addedddd
  const uniqueTalukas = [
    ...new Set(
      (TalukasofDistrict || [])
        .map((val) => String(val?.ULBNameMarathi || "").trim())
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b, "mr"));
  return (
    <div
      className="col-12 pb-5"
      style={{
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      <div
        style={{
          filter: loading ? "blur(4px)" : "none",
          pointerEvents: loading ? "none" : "auto",
          transition: "0.2s ease",
        }}
      >
        <div className="col-11 m-auto">
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <h5 className="fw-bold d-flex align-items-center m-0">
                <img
                  src="/Work-Order-Outwards-Blue64.png"
                  alt="Proposal Report"
                  style={{ width: "24px", height: "24px", marginRight: "6px" }}
                />
                {t("Proposal Status Report")}
              </h5>

              <div className="d-flex gap-2">
                <button
                  className="btn btn-success"
                  onClick={() =>
                    exportTableByClassToExcel(
                      filteredBills,
                      "Proposal_Status_Report.xlsx",
                    )
                  }
                >
                  {t("Download Excel")}
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() =>
                    downloadTableOnlyAsPDF(
                      "ProposalstatusReport",
                      "ProposalstatusReport.pdf",
                      "Proposal Status Report",
                    )
                  }
                >
                  {t("Download PDF")}
                </button>
              </div>
            </div>

            {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "nowrap"
              }}
            >

              {departments.length > 1 && (
  <select
    value={departmentId}
    onChange={(e) => setDepartmentId(e.target.value)}
    style={filterStyle}
  >
    <option value="">{t("All Departments")}</option>
    {departments.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name || d.id}
      </option>
    ))}
  </select>
)}

              {/* Type Of Data */}
              {UserRole === "State" && RoleID == 29 && (
                <select
                  value={typeofData}
                  onChange={(e) => settypeofData(e.target.value)}
                  style={filterStyle}
                >
                  <option value="" disabled selected>
                    {t("Select Head code")}
                  </option>

                  <option value="District">
                    {t("3054-2419(Roads and bridge repair maintenance program)")}
                  </option>

                  <option value="State">
                    {t("2515-1238(MLA Representative)")}
                  </option>
                </select>
              )}

              {/* District Multi Select */}
              {UserRole === "State" && (
                <div style={filterWrapperStyle}>

                  {/* Trigger */}
                  <div
                    onClick={() => setOpenDistrict(true)}
                    style={filterStyle}
                  >
                    {SelectedDistrict.length > 0
                      ? SelectedDistrict.join(", ")
                      : t("Select District")}
                  </div>

                  {/* Dropdown */}
                  {openDistrict && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                        zIndex: 9999
                      }}
                    >
                      {/* All District */}
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "6px 8px",
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          fontSize: "13px"
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={toggleAllDistricts}
                          style={{ marginRight: "6px" }}
                        />

                        {t("All Districts")}
                      </label>

                      {/* District List */}
                      <div
                        style={{
                          maxHeight: "150px",
                          overflowY: "auto"
                        }}
                      >
                        {allDistricts.map((district, index) => (
                          <label
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              cursor: "pointer",
                              fontSize: "13px"
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={SelectedDistrict.includes(district)}
                              onChange={() => toggleDistrict(district)}
                              style={{ marginRight: "6px" }}
                            />

                            {district}
                          </label>
                        ))}
                      </div>

                      {/* OK Button */}
                      <div
                        style={{
                          borderTop: "1px solid #eee",
                          padding: "6px",
                          textAlign: "right"
                        }}
                      >
                        <button
                          onClick={() => setOpenDistrict(false)}
                          style={{
                            padding: "4px 10px",
                            fontSize: "12px",
                            borderRadius: "6px",
                            border: "none",
                            background: "#0d6efd",
                            color: "#fff",
                            cursor: "pointer"
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Taluka */}
              <div style={filterWrapperStyle}>
                <select
                  value={SelectedTalukasofDistrict}
                  onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
                  style={filterStyle}
                >
                  {/* <option value="">
                    {t("Select Taluka")}
                  </option>

                  {TalukasofDistrict?.map((val, index) => (
                    <option
                      key={index}
                      value={val.ULBNameMarathi}
                    >
                      {val.ULBNameMarathi}
                    </option>
                  ))} */}
                  {/* //////////addedd */}
                  <option value="">{t("Select Taluka")}</option>
                  {uniqueTalukas.map((taluka) => (
                    <option key={taluka} value={taluka}>
                      {taluka}
                    </option>
                  ))}
                </select>
              </div>

              {/* Year */}
              <div style={filterWrapperStyle}>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  style={filterStyle}
                >
                  <option value="">
                    {t("Select Year")}
                  </option>

                  <option value="2024-2025">2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </div>

              {/* Search */}
              <div style={filterWrapperStyle}>
                <img
                  src="/Search32.png"
                  alt="Search"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    opacity: 0.6,
                    zIndex: 1
                  }}
                />

                <input
                  type="text"
                  placeholder={t("Search Here")}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    ...filterStyle,
                    padding: "8px 12px 8px 32px",
                    backgroundColor: "#f1f6fc"
                  }}
                />
              </div>
            </div>
          </div>
          {/* TABLE CARD */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "nowrap",
            }}
          >
            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{
                    background: "#2C78DB", overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "600px", // change height as needed
                    position: "relative"
                  }}
                >
                  <table
                    className="m-0 p-0 ProposalstatusReport"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead style={{
                      position: "sticky", backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,
                    }}>
                      {/* Your existing table header */}
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                          fontWeight: "400",
                        }}
                      >
                        <th
                          style={{ minWidth: "100px", padding: "2px" }}
                          rowSpan={2}
                        >
                          {t("Sr No")}
                        </th>
                        {RoleID != 29 ? (
                          ""
                        ) : (
                          <th
                            style={{ minWidth: "180px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Head code")}
                          </th>
                        )}
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Work Name")}
                        </th>
                        {userData?.RoleID !== 41 && (
                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                          >
                            {t("Job ID")}
                          </th>
                        )}
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Proposal Year")}
                        </th>
                        {/* <th style={{ minWidth: "150px", padding: "8px" }}>{t("Work Name")}</th> */}
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("District")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Taluka")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Proposal File No")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Work Amount")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Creation Date")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          colSpan={8}
                        >
                          {t("Status")}
                        </th>
                      </tr>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Proposal")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("GR")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Technical Sanction")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Work Order")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Physical Progress")}
                        </th>
                        {/* <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Demand Request")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Limit Allocation")}
                        </th> */}
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {t("Bill Creation")}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <>
                        {displayedGRS.length === 0 ? (
                          <tr>
                            <td
                              colSpan={18}
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          displayedGRS.map((proposal, index) => (
                            <tr
                              key={proposal.ProposalID || index}
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <td style={{ padding: "8px 8px" }}>
                                {indexOfFirst + index + 1}
                              </td>
                              {RoleID != 29 ? (
                                ""
                              ) : (
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.HeadCode}
                                </td>
                              )}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.Work_name}
                              </td>{" "}
                              {userData?.RoleID !== 41 && (
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.JOB_ID}
                                </td>
                              )}
                              {/* Work Name */}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.Proposal_year}
                              </td>{" "}
                              {/* Proposal Year */}
                              {/* <td style={{ padding: '8px 8px' }}>{proposal.Work_name}</td> */}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.District}
                              </td>{" "}
                              {/* District */}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.Taluka}
                              </td>{" "}
                              {/* Taluka */}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.Proposal_fileNumber}
                              </td>{" "}
                              {/* Proposal File no  */}
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.Proposal_amount}
                              </td>{" "}
                              {/* GR Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {
                                  formatDateTime(proposal.created_at)
                                }
                              </td>{" "}
                              {/* Technical Sanction Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.ProposalStatus)}
                              </td>{" "}
                              {/* Work Order Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.GRStatus)}
                              </td>{" "}
                              {/* Physical Progress Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.TechnicalSanctionStatus)}
                              </td>{" "}
                              {/* Demand Request Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.WorkOrderStatus)}
                              </td>{" "}
                              {/* Work Order Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.PhysicalProgressValue)}
                              </td>{" "}
                              {/* <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.DemandRequestStatus)}
                              </td>{" "}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.LimitAllocation)}
                              </td>{" "} */}
                              {/* Physical Progress Status */}
                              <td style={{ padding: "8px 8px" }}>
                                {renderStatus(proposal.BillStatus)}
                              </td>{" "}
                              {/* Demand Request Status */}
                            </tr>
                          ))
                        )}
                        <tr
                          style={{
                            fontWeight: "600",
                            backgroundColor: "#f0f0f0",
                            fontSize: "18px",
                          }}
                        >
                          <td colSpan={(RoleID != 29 && RoleID == 41) ? 5 : 7} style={{ textAlign: "right", padding: "8px" }}>
                            {t("Page Total")}
                          </td>

                          <td style={{ padding: "8px" }}  >
                            ₹ {pagetotalProposalAmount.toLocaleString("en-IN")}
                          </td>

                          {/* remaining columns */}
                          <td colSpan={20}></td>
                        </tr>
                        <tr
                          style={{
                            fontWeight: "600",
                            backgroundColor: "#f0f0f0",
                            fontSize: "18px",
                          }}
                        >
                          <td colSpan={(RoleID != 29 && RoleID == 41) ? 5 : 7} style={{ textAlign: "right", padding: "8px" }}>
                            {t("Gross Total")}
                          </td>

                          <td style={{ padding: "8px" }}>
                            ₹ {totalProposalAmount.toLocaleString("en-IN")}
                          </td>
                          <td colSpan={20}></td>
                        </tr>
                      </>
                    </tbody>
                  </table>
                </div>

                {/* PAGINATION */}
                <div className="col-12 mt-4 mb-2">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirst + 1} {t("to")}{" "}
                        {Math.min(indexOfLast, filteredBills.length)} {t("of")}{" "}
                        {filteredBills.length} {t("entries")}
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.4)",
            backdropFilter: "blur(2px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="Adminloader"></div>
        </div>
      )}
    </div>
  );
}

export default ProposalReport;
